(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('scd-cart-summary')) {
  customElements.define('scd-cart-summary', class extends HTMLElement {
    connectedCallback() {
      this.refresh = async () => {
        if (this.loading || document.hidden) return;
        this.loading = true;
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          const currency = cart.currency || this.dataset.currency;
          const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
          document.querySelectorAll('scd-cart-summary').forEach(summary => {
            if (summary.classList.contains('scd-cart-summary--footer')) summary.hidden = cart.item_count === 0;
            const threshold = Number(summary.dataset.threshold);
            const remaining = Math.max(0, threshold - cart.total_price);
            summary.querySelector('[data-summary-count]').textContent = cart.item_count === 1 ? summary.dataset.oneItem : summary.dataset.items.replace('[count]', cart.item_count);
            summary.querySelector('[data-summary-total]').textContent = money(cart.total_price) + ' ' + currency;
            summary.querySelector('.scd-cart-summary__shipping').hidden = currency !== 'USD';
            summary.querySelector('[data-summary-message]').textContent = remaining > 0 ? summary.dataset.remaining.replace('[amount]', money(remaining)) : summary.dataset.unlocked;
            summary.querySelector('[data-summary-progress]').value = threshold > 0 ? Math.min(100, Math.max(0, cart.total_price / threshold * 100)) : 0;
          });
        } catch (error) {
          return;
        } finally {
          this.loading = false;
        }
      };
      if (this.classList.contains('scd-cart-summary--footer')) {
        this.measure = () => {
          const space = this.hidden ? 0 : this.getBoundingClientRect().height + (parseFloat(getComputedStyle(this).bottom) || 0) + 8;
          document.documentElement.style.setProperty('--scd-cart-bar-height', `${space}px`);
        };
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this);
        this.measure();
        window.addEventListener('pageshow', this.refresh);
        window.addEventListener('focus', this.refresh);
        document.addEventListener('cart:updated', this.refresh);
        document.addEventListener('cart:change', this.refresh);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('pageshow', this.refresh);
      window.removeEventListener('focus', this.refresh);
      document.removeEventListener('cart:updated', this.refresh);
      document.removeEventListener('cart:change', this.refresh);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const initializeGalleryFinishNotes = () => {
    document.querySelectorAll('[data-gallery-finish-note]').forEach((note) => {
      if (note.dataset.initialized) return;
      const section = note.closest('.product-section');
      const select = section?.querySelector('[data-variant-select]');
      if (!select) return;
      const updateNote = () => {
        note.hidden = Boolean(select.selectedOptions[0]?.dataset.image);
      };
      select.addEventListener('change', updateNote);
      note.dataset.initialized = 'true';
      updateNote();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGalleryFinishNotes);
  } else {
    initializeGalleryFinishNotes();
  }
  document.addEventListener('shopify:section:load', initializeGalleryFinishNotes);
})();

// Product page: a slim buy bar once the real Add to cart button has scrolled away. It only
// clicks that button, so the form, vehicle checks and cart behaviour stay exactly the same.
(() => {
  const init = () => {
    document.querySelectorAll('.bas-pdp').forEach((page) => {
      const bar = page.querySelector('[data-pdp-bar]');
      const real = page.querySelector('[data-buy-button]');
      if (!bar || !real || bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const buy = bar.querySelector('[data-pdp-bar-buy]');
      const price = bar.querySelector('[data-pdp-bar-price]');
      const image = bar.querySelector('[data-pdp-bar-image]');
      const sourcePrice = page.querySelector('[data-product-price]');
      const sourceImage = page.querySelector('[data-main-image]');
      const sync = () => {
        buy.textContent = real.textContent.trim();
        buy.disabled = real.disabled;
        if (price && sourcePrice) price.textContent = sourcePrice.textContent.trim();
        if (image && sourceImage && sourceImage.currentSrc) image.src = sourceImage.currentSrc;
      };
      sync();
      new MutationObserver(sync).observe(real, { attributes: true, childList: true, characterData: true, subtree: true });
      if (sourcePrice) new MutationObserver(sync).observe(sourcePrice, { childList: true, characterData: true, subtree: true });
      if (sourceImage) sourceImage.addEventListener('load', sync);
      buy.addEventListener('click', () => {
        if (real.disabled) return;
        real.scrollIntoView({ behavior: 'smooth', block: 'center' });
        real.click();
      });
      const show = (on) => {
        bar.classList.toggle('is-shown', on);
        bar.setAttribute('aria-hidden', String(!on));
        buy.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(([entry]) => {
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(real);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // "See fitment" in the buy column opens the Fitment tab before the page scrolls to it.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-open-tab]');
    if (!link) return;
    document.querySelector(`[data-product-tab="${link.dataset.openTab}"]`)?.click();
  });
  // Parts listed for many platforms show the first twelve; this reveals the rest.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fit-all]');
    if (!button) return;
    const list = document.getElementById(button.getAttribute('aria-controls'));
    if (!list) return;
    const open = !list.classList.contains('is-open');
    list.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', String(open));
    if (!button.dataset.moreLabel) button.dataset.moreLabel = button.textContent;
    button.textContent = open ? button.dataset.lessLabel : button.dataset.moreLabel;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
